import { Controller } from "@hotwired/stimulus"

// Frame navigations do not update <title>. The server already computed the title
// for this pane (`data-page-title`); this writes it onto the document when the
// pane lands.
//
// A morph refresh can rewrite <title> from a response that only knows the layout
// default. Re-applying after morph keeps a specific title from collapsing back
// to the brand. Equality-checked so a cable refresh of the same pane does not
// flicker the tab.
export default class extends Controller {
  connect() {
    this.apply()
  }

  apply() {
    const title = this.element.dataset.pageTitle
    if (!title || document.title === title) return

    document.title = title
  }
}
